import React, { Component } from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react/lib/DetailsList';
import { Button } from '@fluentui/react/lib/Button';
import { Collapsible } from '../Controls/Collapsible';
const columns = [
    {
        key: "formulaName",
        fieldName: "formulaName",
        name: "Name",
        minWidth: 200,
        maxWidth: 200
    },
    {
        key: "configField",
        fieldName: "configField",
        name: "Field",
        minWidth: 200,
        maxWidth: 200
    },
    {
        key: "configUnit",
        fieldName: "configUnit",
        name: "Unit",
        minWidth: 200,
        maxWidth: 200
    },
    {
        key: "formula",
        fieldName: "formula",
        name: "Formula",
        minWidth: 200,
        maxWidth: 800,
        isMultiline: true,
    },
    {
        key: "result",
        fieldName: "result",
        name: "Result",
        minWidth: 200,
        maxWidth: 200
    },
    {
        key: "error",
        fieldName: "error",
        name: "Error",
        minWidth: 200,
        maxWidth: 200,
        isMultiline: true
    }
];

export class CalculationInfo extends Component {
    static displayName = CalculationInfo.name;

    constructor(props) {
        super(props)

        this.onSaveCsv = this.onSaveCsv.bind(this);
    }
    componentDidMount() {

    }
    onSaveCsv() {

        var items = this.props.items;
        if ((!items) || items.length == 0) {
            return;
        }
        var props = [];
        Object.keys(items[0]).forEach(el => {
            return props.push(el)
        });
        var strArr = [props,
            ...items.map(itm => {
                var vals = [];
                Object.keys(itm).forEach(el => {
                    return vals.push(itm[el]);
                });
                return vals;
            })];
        var strData = strArr.map(e => e.join(","))
            .join("\n");



        var blob = new Blob([strData], { type: "text/csv" });
        var fName = "CalculationInfo.csv";
        if (typeof navigator.msSaveBlob == "function") {
            return navigator.saveBlob(blob, fName);
        }

        var saver = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
        var blobUrl = saver.href = URL.createObjectURL(blob),
            body = document.body;
        saver.download = fName;
        body.appendChild(saver);
        saver.dispatchEvent(new MouseEvent("click"));
        body.removeChild(saver);
        URL.revokeObjectURL(blobUrl);
    }
    render() {

        var items = [];
        if (this.props.items) {
            items = this.props.items;
        }
        return (
            <div>
                <Collapsible header={"Calculation Info"}>
                    <Button className="d-print-none" text="Export to CSV" onClick={this.onSaveCsv} />
                    <DetailsList
                        items={items}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        layoutMode={DetailsListLayoutMode.justified}
                        isCompactMode={true}
                    />
                </Collapsible>
            </div>)
    }
}
